import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { ProdutosPorCategoriaData } from '../../data/graficosData';

interface PieChartProdutosCategoriaProps {
  data: ProdutosPorCategoriaData[];
  height?: number;
  showLegend?: boolean;
}

// Paleta profissional monocromática (tons de azul)
const COLORS = [
  '#1e40af', // blue-800 - azul escuro
  '#3b82f6', // blue-500 - azul médio
  '#60a5fa', // blue-400 - azul claro
  '#2563eb', // blue-600 - azul médio-escuro
  '#93c5fd', // blue-300 - azul muito claro
  '#1e3a8a', // blue-900 - azul muito escuro
  '#475569', // slate-600 - cinza-azulado
  '#64748b', // slate-500 - cinza-azulado claro
];

export const PieChartProdutosCategoria = ({ data, height = 300, showLegend = true }: PieChartProdutosCategoriaProps) => {
  // Custom tooltip
  const CustomTooltip = ({ active, payload }: any) => {
    if (active && payload && payload.length) {
      const item = payload[0].payload;

      return (
        <div className="bg-white dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-700 rounded-lg shadow-lg p-4 min-w-[260px]">
          <p className="font-bold text-gray-900 dark:text-white text-sm mb-2 border-b border-gray-200 dark:border-gray-700 pb-2">
            {item.categoria}
          </p>

          <div className="space-y-2">
            <div className="flex justify-between items-center">
              <span className="text-sm text-gray-600 dark:text-gray-400">Quantidade:</span>
              <span className="font-bold text-lg text-blue-700">
                {item.quantidade.toLocaleString('pt-BR')}
              </span>
            </div>

            <div className="flex justify-between items-center">
              <span className="text-sm text-gray-600 dark:text-gray-400">Participação:</span>
              <span className="font-bold text-lg text-blue-600">
                {item.porcentagem.toFixed(1)}%
              </span>
            </div>

            <div className="pt-2 mt-2 border-t border-gray-200 dark:border-gray-700">
              <div className="flex justify-between items-center">
                <span className="text-xs text-gray-500 dark:text-gray-400">Valor total:</span>
                <span className="font-semibold text-slate-700 dark:text-slate-400">
                  R$ {(item.valorTotal / 1000000).toFixed(1)}M
                </span>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return null;
  };

  // Custom label para mostrar % nas fatias
  const renderCustomLabel = (entry: any) => {
    return `${entry.porcentagem.toFixed(1)}%`;
  };

  return (
    <ResponsiveContainer width="100%" height={height}>
      <PieChart>
        <Pie
          data={data}
          cx="50%"
          cy="50%"
          labelLine={false}
          label={renderCustomLabel}
          outerRadius={height * 0.35}
          fill="#8884d8"
          dataKey="quantidade"
        >
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
        <Tooltip content={<CustomTooltip />} />
        {showLegend && (
          <Legend
            verticalAlign="bottom"
            height={36}
            wrapperStyle={{
              paddingTop: '20px',
              fontSize: '12px',
            }}
          />
        )}
      </PieChart>
    </ResponsiveContainer>
  );
};
